import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class SearchService extends BasicService {
    search(query, type, select) {
        let selectQuery = select ? "&select=" + select : "";
        
        return this.checkError(axios.get(this.API_URL + 'search/' + query + '?type=' + type + selectQuery, { headers: authHeader() }));
    }
}

export default new SearchService();